// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__vFdQn","tooltipHidden":"Tooltip_tooltipHidden__OQMFN","tooltip_text":"Tooltip_tooltip_text__NnYgT","exit_icon":"Tooltip_exit_icon__lSeAj"};